/* eslint no-nested-ternary:off */

const getApiUrl = () => {
  switch (process.env.NODE_ENV) { // eslint-disable-line default-case
    case "development":
      return "http://localhost:3000";
    case "test":
      return "https://api-staging.culturehq.com";
    case "production":
      if (window.location.host.split(".")[0] === "platform-staging") {
        return "https://api-staging.culturehq.com";
      }

      return window.location.host.split(".")[0] === "eu-platform" ? "https://uk-api.culturehq.com" : "https://api.culturehq.com";
  }

  return "https://api.culturehq.com";
};

const apiBase = getApiUrl();

export default apiBase;
